<template>
    <div class="order-products">
        <div class="flex justify-between font-bold mb-4">
            <div class="flex-1 mr-2">Omschrijving</div>
            <div class="w-48 mr-2">Artikel nr. / Afmeting</div>
            <div class="w-32 mr-2">Aantal</div>
            <div class="w-32 mr-2">Eenheidsprijs</div>
            <div class="w-32">Totale prijs</div>
            <div class="w-24" />
        </div>
        <OrderRow
            v-for="row in rows"
            :row="row"
            :index="row.id"
            :key="row.id"
        />
        <div class="flex">
            <button
                v-if="rows.filter(row => !row.product_id && row.type === 'product').length === 0"
                @click.prevent="addProductRow()"
                class="btn-outline flex items-center mr-4"
            >
                <Icon name="plus-circle" class="mr-1" /> Product regel toevoegen
            </button>
            <button
                @click.prevent="addCommentRow()"
                class="btn-outline flex items-center"
            >
                <Icon name="plus-circle" class="mr-1" /> Opmerking regel toevoegen
            </button>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import { createHelpers } from 'vuex-map-fields';

    import OrderRow from '@/components/orders/OrderRow';

    const { mapMultiRowFields } = createHelpers({
        getterType: 'order/getField',
        mutationType: 'order/updateField',
    });

    export default {
        name: 'OrderRows',
        components: {
            OrderRow,
        },
        props: {
            old: {
                type: [Object, Array],
                required: false,
                default: null,
            },
        },
        created() {
            if (this.old) this.fillOldData();
        },
        computed: {
            ...mapMultiRowFields(['rows']),
        },
        methods: {
            ...mapActions('order', [
                'addProductRow',
                'addCommentRow',
            ]),

            fillOldData() {
                if (this.old) this.removeRow(1);

                Object.values(this.old).forEach((row) => {
                    this.addProductRow({
                        id: row.id,
                        product_sku: row.product_sku,
                        product_unit_id: row.product.product_unit_id,
                        quantity: row.quantity,
                        product_name: row.product_name,
                        product_id: row.product_id,
                        type: 'product',
                        sales_price: parseFloat(row.sales_price),
                        total_price: parseFloat(row.total_price),
                    });
                });
            },
        },
    };
</script>
